/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import md5 from 'crypto-js/md5';
import { preparePath } from 'utils/preparePath';
import { mockupResponse } from 'utils/mockupResponse';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  users: '/users',
  session: '/users/session',
  login: '/users/signin',
  signup: '/users/signup',
  password: '/users/password',
  recoverPassword: '/users/recoveryPassword',
  logout: '/users/logout',
  otpConfiguration: '/users/otp/configuration',
  sessionToken: '/users/session/token',
  signinWithToken: '/users/signin/token',
  getUserOtp: '/users/clients/:id/otp',
  checkOtp: '/users/clients/:id/verify',
  checkLinkOtp: '/users/clients/:id/link/verify',
  setNotificationsToken: '/users/notifications/tokens',
  setNotificationsTokenUser: '/users/notifications/tokens/:token',
  setPublicNotificationsToken: '/users/notifications/tokens/public',
  tokensPublic: '/users/notifications/tokens/public',
  userAddress: '/users/clients/address',
  clientsLink: '/users/clients/link',
  identifiersOtp: '/users/identifier/otp',
  identifiersConfirm: '/users/identifier/confirm',
  avatar: '/users/avatar',
  gestopagoUrl: '/gestopagos/url',
  searchClient: '/users/clients/:id',
  signupOTP: '/users/signup/otp',
  signupOTPVerify: '/users/signup/otp/verify',
  signupBasic: '/users/signup/basic',
  signupComplete: '/users/signup/complete',
  completeClientOnboarding: '/users/clients/complete-onboarding',
  idMissionSession: '/idmission/session',
  idMissionLog: '/idmission/log',
  idMissionVerify: '/idmission/verify',
};

export default {
  session() {
    return ApiFetchInstance.get(URLS.session);
  },
  logout() {
    return ApiFetchInstance.get(URLS.logout);
  },
  login(data) {
    return ApiFetchInstance.post(URLS.login, {
      email: data.email || '',
      password: data.password || '',
      sign_in_type: data.signInType || 'EMAIL',
      id_client: data.idClient || '',
      welcome_email: data.welcome_email || false,
    });
  },
  signup(data) {
    return ApiFetchInstance.post(URLS.signup, data);
  },
  recoverPassword(data) {
    return ApiFetchInstance.post(URLS.recoverPassword, data);
  },
  setPassword(data, config = {}) {
    return ApiFetchInstance.post(URLS.password, data, config); // data = { token, password }, config = { params: {}, headers: {} }
  },
  editPassword(data) {
    return ApiFetchInstance.put(URLS.password, {
      old_password: data.oldPassword || '',
      new_password: data.newPassword || '',
    });
  },
  getOtpConfiguration() {
    return ApiFetchInstance.get(URLS.otpConfiguration);
  },
  getSessionToken() {
    return ApiFetchInstance.post(URLS.sessionToken);
  },
  signinWithToken(data) {
    return ApiFetchInstance.post(URLS.signinWithToken, data);
  },
  createPassword(token, password) {
    return ApiFetchInstance.post(URLS.password, { token, password });
  },
  getUserOtp(id, type) {
    return ApiFetchInstance.get(preparePath(URLS.getUserOtp, { id }, { type }));
  },
  checkOtp(id, otp) {
    return ApiFetchInstance.post(preparePath(URLS.checkOtp, { id }, { otp }));
  },
  checkLinkOtp(id, otp) {
    return ApiFetchInstance.post(preparePath(URLS.checkLinkOtp, { id }, { otp }));
  },
  unlinkSAP() {
    return ApiFetchInstance.delete(URLS.clientsLink);
  },
  setNotificationsToken(data) {
    return ApiFetchInstance.post(URLS.setNotificationsToken, data);
  },
  deleteNotificationsToken(data) {
    return ApiFetchInstance.delete(preparePath(URLS.setNotificationsTokenUser, { token: data.token }));
  },
  setPublicNotificationsToken(data) {
    return ApiFetchInstance.post(URLS.setPublicNotificationsToken, data);
  },
  deletePublicNotificationsToken(data) {
    return ApiFetchInstance.delete(URLS.setPublicNotificationsToken, { data });
  },
  createPublicToken(token) {
    ApiFetchInstance.defaults.headers.common['X-Token'] = md5(token);
    return ApiFetchInstance.post(URLS.tokensPublic, { token });
  },
  getUserAddress() {
    return ApiFetchInstance.get(URLS.userAddress);
  },
  editUser(data) {
    return ApiFetchInstance.put(URLS.users, data);
  },
  changeEmailPhone(data) {
    return ApiFetchInstance.put(URLS.identifiersOtp, data);
  },
  confirmChangeEmailPhone(data) {
    return ApiFetchInstance.put(URLS.identifiersConfirm, data);
  },
  editAvatar(avatar) {
    return ApiFetchInstance.post(URLS.avatar, { avatar }, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  getGestopagoUrl() {
    return ApiFetchInstance.get(URLS.gestopagoUrl);
  },
  searchClient(type, value) {
    return ApiFetchInstance.get(preparePath(URLS.searchClient, { id: value }, { type }));
  },
  createIdMissionSession() {
    return ApiFetchInstance.get(URLS.idMissionSession);
  },
  verifyIdMissionSelfie(selfie) {
    return ApiFetchInstance.post(URLS.idMissionVerify, { selfie });
  },
  createIdMissionLog(data) {
    return ApiFetchInstance.post(URLS.idMissionLog, data);
  },
  sendSignupOTP(email, phone, channel) {
    const body = { email, phone };
    if (channel) {
      body.channel = channel;
    }
    return ApiFetchInstance.post(URLS.signupOTP, body);
  },
  /**
   * Confirma celular y correo antes de IDMission.
   * No invalida el OTP: /signup/complete lo vuelve a recibir.
   * El canal (WHATSAPP/SMS) solo aplica al envío.
   */
  verifySignupOTP(data = {}) {
    return ApiFetchInstance.post(URLS.signupOTPVerify, {
      phone: data.phone,
      otp_phone: data.otp_phone,
      email: data.email,
      otp_email: data.otp_email,
    });
  },
  // El alta nueva ya no llama este endpoint. Se conserva el cliente HTTP.
  signupBasic(data) {
    return ApiFetchInstance.post(URLS.signupBasic, data);
  },
  signupComplete(data) {
    return ApiFetchInstance.post(URLS.signupComplete, data);
  },
  completeClientOnboarding(data) {
    return ApiFetchInstance.post(URLS.completeClientOnboarding, data);
  },
};
